import styled from 'styled-components';

export const Container = styled.form`
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
`;
